// extracted by mini-css-extract-plugin
export default {"header":"ProposalHeader_header__+t+HS","meta":"ProposalHeader_meta__VgjMp","title":"ProposalHeader_title__hEsL9","date":"ProposalHeader_date__C5D-U"};